import React, { useEffect, useState } from "react";
import {
  getMenuCollapsedMemory,
  setMenuCollapsedmemory,
  getButtonCollapsedMemory,
  setButtonCollapsedmemory,
  getVersionApp,
} from "../data/memory";
import { useWindowSize } from "../componets/useWindowSize";
import { resetList } from "../data/resetList";
import { autoResetJogosMensal } from "../data/autoClear";
import AlertSuccess from "../componets/AlerSuccess";
import AlertPerigo from "../componets/AlertPerigo";
import AppShell from "../componets/AppShell";
import {
  deletarTorneio,
  escutarResultados,
  getClassificacaoTorneio,
  getNomesPorId,
  JogadorStats,
  listenTorneio,
  salvarResultado,
} from "../data/torneioService";
import { getUserId } from "../data/userService";
import { getDatabase, ref, onValue } from "firebase/database";

const TorneioJogos: React.FC = () => {
  const { width } = useWindowSize();
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(
    getMenuCollapsedMemory()
  );
  const [isButtonCollapsed, setIsButtonCollapsed] = useState(
    getButtonCollapsedMemory()
  );
  const [loading, setLoading] = useState(true);
  const [quadras, setQuadras] = useState<any[][]>([]);
  const [nomes, setNomes] = useState<Record<string, string>>({});
  const [isUserInTorneio, setIsUserInTorneio] = useState(false);
  const [resultados, setResultados] = useState<
    { placar1: number; placar2: number }[]
  >([]);
  const [classificacao, setClassificacao] = useState<JogadorStats[]>([]);
  const [faltandoResultados, setFaltandoResultados] = useState(false);
  const [partidasIncompletas, setPartidasIncompletas] = useState<
    { rodada: number; dupla1: string[]; dupla2: string[] }[]
  >([]);
  const [draftResultadosPorRodada, setDraftResultadosPorRodada] = useState<
    Record<number, { placar1: string; placar2: string }[]>
  >({});
  const [rodadaAtual, setRodadaAtual] = useState(0);
  const [successAlert, setSuccessAlert] = useState({
    open: false,
    message: "",
  });
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSavingResultados, setIsSavingResultados] = useState(false);

  useEffect(() => {
    resetList();
    autoResetJogosMensal();
  }, []);

  useEffect(() => {
    if (width < 1000) {
      setIsMenuCollapsed(true);
      setMenuCollapsedmemory(true);
    } else if (!getButtonCollapsedMemory()) {
      setIsMenuCollapsed(false);
      setMenuCollapsedmemory(false);
    }
  }, [width]);

  useEffect(() => {
    const unsubscribe = listenTorneio((data) => {
      const existe = !!data?.criadoEm;
      setLoading(false);
      const userId = getUserId();
      if (!existe) {
        return;
      }
      setIsUserInTorneio(Boolean(userId && data?.inscritos?.[userId]));
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    getNomesPorId().then(setNomes);
  }, []);

  function getNome(userId: string) {
    return nomes[userId] || userId;
  }

  useEffect(() => {
    const unsubscribe = escutarResultados(rodadaAtual, setResultados);
    return () => unsubscribe(); // limpa o listener ao trocar de rodada
  }, [rodadaAtual]);

  useEffect(() => {
    const unsubscribe = getClassificacaoTorneio((novaClassificacao, partidas) => {
      setClassificacao(novaClassificacao);

      const incompletas: {
        rodada: number;
        dupla1: string[];
        dupla2: string[];
      }[] = [];

      partidas.forEach((rodada, rodadaIndex) => {
        rodada.forEach((partida) => {
          if (
            partida.dupla1Resultado == null ||
            partida.dupla2Resultado == null
          ) {
            incompletas.push({
              rodada: rodadaIndex + 1,
              dupla1: partida.dupla1 || [],
              dupla2: partida.dupla2 || [],
            });
          }
        });
      });

      setPartidasIncompletas(incompletas);
      setFaltandoResultados(incompletas.length > 0);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    setDraftResultadosPorRodada((current) => {
      return {
        ...current,
        [rodadaAtual]: resultados.map((resultado) => ({
          placar1:
            resultado?.placar1 === -1 || resultado?.placar1 == null
              ? ""
              : String(resultado.placar1),
          placar2:
            resultado?.placar2 === -1 || resultado?.placar2 == null
              ? ""
              : String(resultado.placar2),
        })),
      };
    });
  }, [resultados, rodadaAtual]);

  // NOVO: ouvindo as partidas geradas no Firebase
  useEffect(() => {
    const db = getDatabase();
    const partidasRef = ref(db, "torneio/super/partidas");
    const unsubscribe = onValue(partidasRef, (snapshot) => {
      const partidas = snapshot.val();
      if (partidas) {
        setQuadras(partidas);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleMenuToggle = () => {
    const newCollapsed = !isMenuCollapsed;
    setIsMenuCollapsed(newCollapsed);
    setButtonCollapsedmemory(newCollapsed);
    setMenuCollapsedmemory(newCollapsed);
    setIsButtonCollapsed(!isButtonCollapsed);
  };

  const handleDraftChange = (
    quadraIndex: number,
    dupla: "placar1" | "placar2",
    valor: string
  ) => {
    if (valor !== "" && !/^\d+$/.test(valor)) {
      return;
    }

    setDraftResultadosPorRodada((current) => {
      const rodadaDraft = [...(current[rodadaAtual] || [])];
      const existing = rodadaDraft[quadraIndex] || { placar1: "", placar2: "" };
      rodadaDraft[quadraIndex] = { ...existing, [dupla]: valor };

      return {
        ...current,
        [rodadaAtual]: rodadaDraft,
      };
    });
  };

  const handleSalvarResultados = async () => {
    try {
      setIsSavingResultados(true);

      for (const [rodadaKey, draftResultados] of Object.entries(
        draftResultadosPorRodada
      )) {
        const rodada = Number(rodadaKey);

        for (let index = 0; index < draftResultados.length; index++) {
          const draft = draftResultados[index];
          if (!draft) continue;

          const valores = [
            { campo: "dupla1" as const, valor: draft.placar1 },
            { campo: "dupla2" as const, valor: draft.placar2 },
          ];

          for (const item of valores) {
            if (item.valor === "") continue;

            const numero = parseInt(item.valor);
            if (isNaN(numero) || numero < 0 || numero > 6) {
              continue;
            }

            await salvarResultado(rodada, index, item.campo, numero);
          }
        }
      }

      setSuccessAlert({
        open: true,
        message: "Resultados salvos com sucesso!",
      });
    } catch (err) {
      console.error("Erro ao salvar resultados:", err);
    } finally {
      setIsSavingResultados(false);
    }
  };

  const handleSalvarRodada = async (rodada: number) => {
    const draftResultados = draftResultadosPorRodada[rodada] || [];

    for (let index = 0; index < draftResultados.length; index++) {
      const draft = draftResultados[index];
      if (!draft) continue;

      const valores = [
        { campo: "dupla1" as const, valor: draft.placar1 },
        { campo: "dupla2" as const, valor: draft.placar2 },
      ];

      for (const item of valores) {
        if (item.valor === "") continue;

        const numero = parseInt(item.valor);
        if (isNaN(numero) || numero < 0 || numero > 6) {
          continue;
        }

        await salvarResultado(rodada, index, item.campo, numero);
      }
    }
  };

  const renderMedalha = (index: number) => {
    switch (index) {
      case 0:
        return "🥇";
      case 1:
        return "🥈";
      case 2:
        return "🥉";
      default:
        return `${index + 1}`;
    }
  };

  const handleChangeRodada = async (novaRodada: number) => {
    if (novaRodada === rodadaAtual) return;

    try {
      setIsSavingResultados(true);
      await handleSalvarRodada(rodadaAtual);
      setRodadaAtual(novaRodada);
    } catch (error) {
      console.error("Erro ao salvar antes de trocar rodada:", error);
    } finally {
      setIsSavingResultados(false);
    }
  };

  const todosResultadosSalvos = quadras.length > 0 && !faltandoResultados;

  return (
    <>
      <AlertSuccess
        isOpen={successAlert.open}
        message={successAlert.message}
        onClose={() => setSuccessAlert({ open: false, message: "" })}
      />
      <AlertPerigo
        isOpen={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={async () => {
          try {
            setIsDeleting(true);
            await deletarTorneio();
            setSuccessAlert({
              open: true,
              message: "Torneio deletado com sucesso!",
            });
            setIsDeleteConfirmOpen(false);
          } catch (error) {
            console.error("Erro ao deletar torneio:", error);
          } finally {
            setIsDeleting(false);
          }
        }}
        message="Você tem certeza que deseja deletar o torneio?"
      />
      <AppShell
        isMenuCollapsed={isMenuCollapsed}
        onToggleMenu={handleMenuToggle}
      >
        {loading ? (
          <div className="panel-glass mt-2 flex items-center justify-center rounded-[2rem] py-12">
            <div className="flex items-center space-x-2 animate-pulse">
              <div className="h-8 w-8 rounded-full bg-pink-300"></div>
              <div className="h-8 w-8 rounded-full bg-pink-400"></div>
              <div className="h-8 w-8 rounded-full bg-rose-500"></div>
            </div>
          </div>
        ) : (
          <>
            {!todosResultadosSalvos ? (
              <section className="panel-glass rounded-[2rem] p-4 text-white sm:p-8">
                <div className="mb-6 flex items-center justify-between gap-3">
                  <h2 className="text-xl font-semibold sm:text-2xl">
                    Jogos do torneio
                  </h2>
                  <span className="rounded-full border border-pink-300/20 bg-pink-500/10 px-3 py-1 text-xs font-medium text-pink-100">
                    Rodada {rodadaAtual + 1}
                  </span>
                </div>
                {quadras.length > 0 && (width < 780 ? isMenuCollapsed : true) && (
                  <div className="mx-auto max-w-96 sm:max-w-full sm:px-4">
                    <div className="mb-4 grid grid-cols-1 gap-4 text-center sm:grid-cols-2 lg:grid-cols-3">
                      {quadras[rodadaAtual].map((quadra, index) => {
                        const podeEditarDupla1 = isUserInTorneio;
                        const podeEditarDupla2 = isUserInTorneio;

                        const mostrarPlacar1 =
                          resultados[index]?.placar1 === -1
                            ? 0
                            : resultados[index]?.placar1;
                        const mostrarPlacar2 =
                          resultados[index]?.placar2 === -1
                            ? 0
                            : resultados[index]?.placar2;

                        return (
                          <div
                            key={index}
                            className="panel-soft rounded-[1.5rem] px-3 py-4 text-sm sm:px-4 sm:py-6"
                          >
                            <div className="mt-2 text-sm font-semibold text-pink-300 sm:text-lg">
                              Rodada {rodadaAtual + 1} - Quadra {index + 1}
                            </div>

                            <div className="mt-3 flex items-center rounded-xl border border-pink-300/30 bg-pink-500/10 px-3 py-2">
                              <div className="w-full text-left">
                                {quadra.dupla1.map((jogador: string, i: number) => (
                                  <div
                                    key={i}
                                    className="truncate text-sm font-semibold text-pink-100 sm:text-base"
                                  >
                                    {getNome(jogador)}
                                  </div>
                                ))}
                              </div>
                              {podeEditarDupla1 ? (
                                <input
                                  key={`dupla1-${rodadaAtual}-${index}`}
                                  className="h-10 w-10 rounded-md border border-pink-400 bg-white text-center text-xl text-pink-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500"
                                  placeholder="0"
                                  value={
                                    draftResultadosPorRodada[rodadaAtual]?.[index]
                                      ?.placar1 ?? ""
                                  }
                                  onChange={(e) =>
                                    handleDraftChange(
                                      index,
                                      "placar1",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                <div className="flex h-10 w-10 select-none items-center justify-center text-center text-xl font-bold text-pink-100">
                                  {mostrarPlacar1}
                                </div>
                              )}
                            </div>

                            <div className="my-2 text-sm font-bold text-white sm:my-3 sm:text-base">
                              VS
                            </div>

                            <div className="flex items-center rounded-xl border border-pink-300/30 bg-pink-500/10 px-3 py-2">
                              <div className="w-full text-left">
                                {quadra.dupla2.map((jogador: string, i: number) => (
                                  <div
                                    key={i}
                                    className="truncate text-sm font-semibold text-pink-100 sm:text-base"
                                  >
                                    {getNome(jogador)}
                                  </div>
                                ))}
                              </div>
                              {podeEditarDupla2 ? (
                                <input
                                  key={`dupla2-${rodadaAtual}-${index}`}
                                  className="h-10 w-10 rounded-md border border-pink-400 bg-white text-center text-xl text-pink-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500"
                                  placeholder="0"
                                  value={
                                    draftResultadosPorRodada[rodadaAtual]?.[index]
                                      ?.placar2 ?? ""
                                  }
                                  onChange={(e) =>
                                    handleDraftChange(
                                      index,
                                      "placar2",
                                      e.target.value
                                    )
                                  }
                                />
                              ) : (
                                <div className="flex h-10 w-10 select-none items-center justify-center text-center text-xl font-bold text-pink-100">
                                  {mostrarPlacar2}
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {quadras.length > 0 && (width < 780 ? isMenuCollapsed : true) && (
                  <div className="mb-8 flex max-w-full flex-wrap justify-center gap-1 sm:gap-2">
                    {quadras.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => handleChangeRodada(idx)}
                        className={`rounded-md px-3 py-1 font-semibold transition ${
                          idx === rodadaAtual
                            ? "bg-pink-500 text-white"
                            : "bg-white/10 text-zinc-200 hover:bg-pink-500/30"
                        }`}
                      >
                        {idx + 1}
                      </button>
                    ))}
                  </div>
                )}
                <button
                  onClick={handleSalvarResultados}
                  disabled={!isUserInTorneio || isSavingResultados}
                  className={`mb-3 w-full rounded-2xl px-6 py-3 font-semibold text-white shadow-[0_18px_40px_rgba(244,114,182,0.22)] transition ${
                    !isUserInTorneio || isSavingResultados
                      ? "cursor-not-allowed bg-pink-300"
                      : "bg-gradient-to-r from-pink-500 to-rose-500 hover:brightness-105"
                  }`}
                >
                  {isSavingResultados ? "Salvando..." : "Salvar resultados"}
                </button>
              </section>
            ) : null}

            <section className="panel-glass mt-6 rounded-[2rem] p-4 sm:p-8">
              <div className="mb-4 flex items-center justify-between gap-3">
                <h2 className="text-xl font-semibold text-pink-200">
                  Classificação do torneio
                </h2>
              </div>

              <div className="panel-soft overflow-x-auto rounded-[1.5rem]">
                <table className="w-full border-collapse text-left text-white">
                  <thead>
                    <tr className="border-b border-white/10 text-pink-100">
                      <th className="px-4 py-3">Posição</th>
                      <th className="px-4 py-3">Nome</th>
                      <th className="px-4 py-3">Games a Favor</th>
                      <th className="px-4 py-3">Vitórias</th>
                      <th className="px-4 py-3">Saldo Games</th>
                    </tr>
                  </thead>
                  <tbody>
                    {classificacao.map((item, index) => (
                      <tr
                        key={item.userId}
                        className="border-b border-white/8 text-zinc-100"
                      >
                        <td className="px-4 py-3">{renderMedalha(index)}</td>
                        <td className="px-4 py-3">{item.nome}</td>
                        <td className="px-4 py-3">{item.gamesFavor}</td>
                        <td className="px-4 py-3">{item.vitorias}</td>
                        <td className="px-4 py-3">{item.saldoGames}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {faltandoResultados ? (
                <div className="mt-4 rounded-lg border border-yellow-300 bg-yellow-50 px-4 py-3 text-sm text-yellow-800">
                  <p className="font-semibold">
                    Ainda existem partidas incompletas.
                  </p>
                  <p className="mt-1">
                    A classificação pode mudar quando todos os resultados forem
                    preenchidos.
                  </p>
                  <ul className="mt-3 space-y-1">
                    {partidasIncompletas.map((partida, index) => (
                      <li key={index}>
                        <strong>Rodada {partida.rodada}:</strong>{" "}
                        {partida.dupla1.map((id) => getNome(id)).join(" & ")} VS{" "}
                        {partida.dupla2.map((id) => getNome(id)).join(" & ")}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </section>

            <div className="mt-6">
              <button
                onClick={() => setIsDeleteConfirmOpen(true)}
                disabled={isDeleting}
                className={`w-full rounded-2xl px-6 py-3 font-semibold text-white shadow-md transition ${
                  isDeleting
                    ? "cursor-not-allowed bg-red-400"
                    : "bg-red-600 hover:bg-red-700"
                }`}
              >
                {isDeleting ? "Deletando..." : "Deletar torneio"}
              </button>
            </div>

            <div className="w-full mt-auto text-center py-6 flex flex-col items-center space-y-1">
              <span className="text-gray-400 text-xs sm:text-sm">
                Developed by Samuel Stork
              </span>
              <span className="text-gray-400 text-xs sm:text-sm">
                {getVersionApp()}
              </span>
            </div>
          </>
        )}
      </AppShell>
    </>
  );
};

export default TorneioJogos;
